import { AxiosResponse } from 'axios';
import { api } from 'hooks/useApi';

export type LudRaw = {
  id: number;
  lud_code: string;
  lud_description: string;
  lud_district: string;
};

const getAllDistrictCodes = (): Promise<AxiosResponse<LudRaw[]>> => {
  return api.get('/districts/codes/all/');
};

const getDistrictCodesByCity = (
  cityId: string | number,
): Promise<AxiosResponse<LudRaw[]>> => {
  return api.get(`/districts/codes/?city_ids=${cityId}`);
};

export default {
  getAllDistrictCodes,
  getDistrictCodesByCity,
};
